<template>
  <div>
    <Header />
    <b-container class="my-4">
      <h1>Hoops 5×5 Challenge</h1>
      <div class="clearfix">
        <b-img
          width="140"
          class="ml-3 float-right"
          src="../assets/challenge.jpeg"
          rounded="circle"
          fluid
          alt="Hoops 5x5 Challenge"
        />
        <p class="lead">
          Hoops 5×5 Challenge es un <strong class="font-weight-bold">campeonato de basketball</strong>.
          <br>¡Enfréntate a los equipos participantes, todo el año, cuando tú quieras!
        </p>
        <p>
          <strong>¡Organizamos todo!<br>Solo lleva tú equipo o grupo de amigos.</strong>
        </p>
        <h6>Costo:</h6>
        <ul>
          <li><strong>La inscripción es gratis</strong>,<br>solo llena el <b-link href="https://forms.gle/bZoLk79rjnCdkugz7" target="_blank">formulario en línea</b-link>.</li>
          <li>Solo se paga $30 por equipo por juego. Incluye: 4 cuartos de 10 minutos, 1 arbitro, reloj, cancha.</li>
        </ul>
        <p>
          Tendrás acceso a la tabla de posiciones para saber como va tu equipo. ¡Gana partidos y mejora tu posición!
          <br >Categorías: Juvenil - Veteranos.
        </p>
        <p>
          Conoce más de <b-link :to="{ name: 'ChallengeRules' }">las reglas</b-link>.
        </p>
        <p>
          Ver <b-link :to="{ name: 'Challenge' }">la tabla de posiciones</b-link>.
        </p>
      </div>
      <hr />
      <Jumbo
        label="PREGUNTAS:"
      />
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/home/Header.vue'
import Footer from '@/components/home/Footer.vue'
import Jumbo from '@/components/home/Jumbo.vue'
export default {
  components: {
    Header,
    Jumbo,
    Footer
  }
}
</script>
